import './style.scss';
import supportsWebP from 'supports-webp';

document.addEventListener('DOMContentLoaded', () => {
    const heros = document.querySelectorAll('.wp-block-genera-blocks-hero');
    const isImage = /.(jpe?g|png)$/

    heros.forEach((hero) => {
        const { dataset } = hero;
        if (!Object.keys(dataset).length) return;

        let { background, mobileBackground, bgPosition, mobileBgPosition, bgSize, mobileBgSize } = dataset;
        const isMobile = window.matchMedia('(max-width: 768px)').matches;

        let currentBg = isMobile ? mobileBackground : background;
        const currentBgPosition = isMobile ? mobileBgPosition : bgPosition;
        const currentBgSize = isMobile ? mobileBgSize : bgSize;

        if (!!currentBg) {
            supportsWebP.then(supported => {
                if (supported && genblocks.webp_rewrite && isImage.test(currentBg)) {
                    currentBg = `${currentBg}.webp`
                }

                hero.style.setProperty('--background', `url(${currentBg}) no-repeat ${currentBgPosition || 'center'} / ${currentBgSize || 'auto'}`);
            });
        }
    });
});